module.exports = __webpack_public_path__ + "img/f2.fbc37898.jpg";